if (!customElements.get('product-information-tabs')) {
  customElements.define('product-information-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const nav = this.querySelector('[data-tabs-nav]');
      const tabs = [...nav.querySelectorAll('button')];
      const panels = [...this.querySelectorAll('[data-tab-panel]')];
      if (!tabs.length || panels.length !== tabs.length) return;
      const activate = (index, focus = false) => {
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
        });
        if (focus) tabs[index].focus({ preventScroll: true });
      };
      nav.setAttribute('role', 'tablist');
      tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        panels[index].setAttribute('role', 'tabpanel');
        panels[index].tabIndex = 0;
        tab.addEventListener('click', () => activate(index));
        tab.addEventListener('keydown', (event) => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          activate(next, true);
        });
      });
      activate(0);
      this.classList.add('is-enhanced');
      nav.hidden = false;
      this.initialized = true;
    }
  });
}
